import { Controller } from "@hotwired/stimulus"

// Auto-dismisses a flash toast. Turbo-Frame navigation never reloads <body>, so
// without this the toast would linger over the sticky pane headers all session.
export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } }

  connect() {
    this.timeout = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss() {
    this.element.classList.add("flash--dismissing")
    this.element.addEventListener("transitionend", () => this.element.remove(), { once: true })
    // Fallback removal in case no transition fires (e.g. reduced motion).
    setTimeout(() => this.element.remove(), 500)
  }
}
